import React, { Component } from "react";
export default class ErrorPage extends Component {
  render() {
    return (
      <div class='em-l-container em-u-padding-top-double'>
        <div class='em-u-text-align-center'>
          <h1 class='em-u-margin-top'>Access Denied</h1>
          <h4 class='em-u-margin-bottom'>
            You do not have sufficient rights to view this page.
          </h4>
          <h5 class='em-u-font-style-regular'>
            <b>To request access: </b>
            Navigate to{" "}
            <a class='em-c-text-link' href='https://it.na.xom.com/'>
              goto/IT
            </a>{" "}
            and open a request form for <i>LAN Single Group Update</i>. Select
            GSC.EMIT.APP.UDM.SYSADMIN.DEV.UG and add yourself to the request. Provide
            business justification and submit.
          </h5>
        </div>
      </div>
    );
  }
}
